export default {
  // banner item類型
  BANNER_ITEM_TYPE_PHOTO: 'photo',
  BANNER_ITEM_TYPE_VIDEO: 'video',
}
